import { createFileRoute } from '@tanstack/react-router'
import { MarkdownPreview } from '@/components/markdown-preview'
import content from '@/legal/privacy-policy.md?raw'

export const Route = createFileRoute('/legal/privacy')({
  component: PrivacyPolicy,
})

function PrivacyPolicy() {
  return (
    <main className="mx-auto max-w-3xl px-6 py-12">
      <MarkdownPreview
        source={content}
        className="[&_a]:text-primary [&_h1]:mt-8 [&_h1]:mb-4 [&_h1]:text-2xl [&_h1]:font-bold [&_h2]:mt-6 [&_h2]:mb-3 [&_h3]:mt-4 [&_h3]:mb-2 [&_h3]:text-base [&_li]:my-1 [&_ol]:my-3 [&_p]:my-3 [&_ul]:my-3"
      />
    </main>
  )
}
